import _ from 'lodash'
import qs from 'qs'
import { useCallback, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useForm } from 'antd/es/form/Form'
import formatAllDatesAsDayjs from '../../helpers/formatters/format-all-dates-as-dayjs'
import formatAllDatesAsStrings from '../../helpers/formatters/format-all-dates-as-strings'

export default function useFiltersForm() {
    const [form] = useForm()
    const [searchParams, setSearchParams] = useSearchParams()
    const filtersString = searchParams.get('filters') || ''

    useEffect(() => {
        const filters = qs.parse(filtersString)
        const values = formatAllDatesAsDayjs(filters)
        form.setFieldsValue(values)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const setFilters = useCallback(() => {
        const formValues = form.getFieldsValue()
        const formattedFormValues = formatAllDatesAsStrings(formValues)
        const stringifiedFormValues = qs.stringify(formattedFormValues, {
            skipNulls: true,
            filter: (prefix, value) => {
                // Exclude empty strings
                if (value === '') {
                    return
                }
                return value
            },
        })
        const searchParams = new URLSearchParams()

        // тут устанавливаем новые параметры, так как пагинацию надо сбросить
        if (stringifiedFormValues) searchParams.set('filters', stringifiedFormValues)
        setSearchParams(searchParams)
    }, [form, setSearchParams])

    const onClear = () => {
        form.resetFields()
        setFilters()
    }

    const setFiltersRef = useRef(setFilters)
    setFiltersRef.current = setFilters

    const debouncedSetFiltersRef = useRef(_.debounce(() => setFiltersRef.current(), 800))

    useEffect(() => {
        const debouncedSetFilters = debouncedSetFiltersRef.current
        return () => {
            debouncedSetFilters.cancel()
        }
    }, [])

    const onSearch = useCallback(() => {
        debouncedSetFiltersRef.current()
    }, [])

    return { form, onSearch, onClear }
}
